import type { Point, Rect, Tile } from './types';
import { axialToCube, cubeRound, pixelToAxial } from './hexMath';
import type { MapModel } from '../map/mapModel';

export function isPointInRect(p: Point, r: Rect | null): boolean {
    return !!r && p.x >= r.x && p.x <= r.x + r.w && p.y >= r.y && p.y <= r.y + r.h;
}

export function getTileAtWorldPoint(model: MapModel, x: number, y: number): Tile | null {
    const axial = pixelToAxial({ x, y });
    const cube = cubeRound(axialToCube(axial));
    const tile = model.getTileByCube(cube.q, cube.r, cube.s);
    return tile || null;
}
